webpackJsonp([141669503851301,160924362604476,27359460849635],{

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactCore = __webpack_require__(3);
	
	var _SimpleLevel = __webpack_require__(224);
	
	var _SimpleLevel2 = _interopRequireDefault(_SimpleLevel);
	
	var _LevelWithGutters = __webpack_require__(223);
	
	var _LevelWithGutters2 = _interopRequireDefault(_LevelWithGutters);
	
	var _getContainerProps = __webpack_require__(560);
	
	var _getContainerProps2 = _interopRequireDefault(_getContainerProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  title: 'Level',
	  description: '',
	  components: {
	    Level: _reactCore.Level,
	    LevelItem: _reactCore.LevelItem
	  },
	  examples: [{ component: _SimpleLevel2.default, title: 'Simple Level Layout', getContainerProps: _getContainerProps2.default }, { component: _LevelWithGutters2.default, title: 'Level With Gutters', getContainerProps: _getContainerProps2.default }]
	};
	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LevelWithGutters = function (_React$Component) {
	  _inherits(LevelWithGutters, _React$Component);
	
	  function LevelWithGutters() {
	    _classCallCheck(this, LevelWithGutters);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  LevelWithGutters.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.Level,
	      { gutter: 'md' },
	      _react2.default.createElement(
	        _reactCore.LevelItem,
	        null,
	        'Level Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.LevelItem,
	        null,
	        'Level Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.LevelItem,
	        null,
	        'Level Item'
	      )
	    );
	  };
	
	  return LevelWithGutters;
	}(_react2.default.Component);
	
	exports.default = LevelWithGutters;
	LevelWithGutters.__docgenInfo = {
	  'description': '',
	  'displayName': 'LevelWithGutters'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { Level, LevelItem } from '@patternfly/react-core';\n\nclass LevelWithGutters extends React.Component {\n  render() {\n    return (\n      <Level gutter=\"md\">\n        <LevelItem>Level Item</LevelItem>\n        <LevelItem>Level Item</LevelItem>\n        <LevelItem>Level Item</LevelItem>\n      </Level>\n    );\n  }\n}\n\nexport default LevelWithGutters;\n"

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleLevel = function (_React$Component) {
	  _inherits(SimpleLevel, _React$Component);
	
	  function SimpleLevel() {
	    _classCallCheck(this, SimpleLevel);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SimpleLevel.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.Level,
	      null,
	      _react2.default.createElement(
	        _reactCore.LevelItem,
	        null,
	        'Level Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.LevelItem,
	        null,
	        'Level Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.LevelItem,
	        null,
	        'Level Item'
	      )
	    );
	  };
	
	  return SimpleLevel;
	}(_react2.default.Component);
	
	exports.default = SimpleLevel;
	SimpleLevel.__docgenInfo = {
	  'description': '',
	  'displayName': 'SimpleLevel'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { Level, LevelItem } from '@patternfly/react-core';\n\nclass SimpleLevel extends React.Component {\n  render() {\n    return (\n      <Level>\n        <LevelItem>Level Item</LevelItem>\n        <LevelItem>Level Item</LevelItem>\n        <LevelItem>Level Item</LevelItem>\n      </Level>\n    );\n  }\n}\n\nexport default SimpleLevel;\n"

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactStyles = __webpack_require__(5);
	
	var _reactTokens = __webpack_require__(16);
	
	var styles = _reactStyles.StyleSheet.create({
	  demoLayout: {
	    '& .pf-l-level > div': {
	      borderWidth: _reactTokens.global_BorderWidth_md.var,
	      borderStyle: 'dashed',
	      borderColor: _reactTokens.global_BorderColor.var
	    }
	  }
	});
	
	exports.default = function () {
	  return { className: (0, _reactStyles.css)(styles.demoLayout) };
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.level_package = exports.level_docs = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LevelDocs = __webpack_require__(559);
	
	var _LevelDocs2 = _interopRequireDefault(_LevelDocs);
	
	var _componentDocs = __webpack_require__(15);
	
	var _componentDocs2 = _interopRequireDefault(_componentDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rawExamples = [{ name: 'LevelWithGutters', path: '../../react-core/src/layouts/Level/examples/LevelWithGutters.js', file: __webpack_require__(463) }, { name: 'SimpleLevel', path: '../../react-core/src/layouts/Level/examples/SimpleLevel.js', file: __webpack_require__(464) }];
	var images = [{ name: 'img_avatar.svg', file: __webpack_require__(7) }, { name: 'l_pf-reverse-164x11.png', file: __webpack_require__(8) }, { name: 'pf_logo.svg', file: __webpack_require__(9) }, { name: 'pf_mini_logo_white.svg', file: __webpack_require__(10) }, { name: 'img_avatar.svg', file: __webpack_require__(12) }, { name: 'pf_logo.svg', file: __webpack_require__(13) }, { name: 'pf_logo_color.svg', file: __webpack_require__(14) }, { name: 'pfbg_992.jpg', file: __webpack_require__(11) }];
	
	var level_docs = exports.level_docs = _LevelDocs2.default;
	var level_package = exports.level_package = 'react-core';
	
	exports.default = function () {
	    return _react2.default.createElement(_componentDocs2.default, _extends({ rawExamples: rawExamples, images: images }, _LevelDocs2.default));
	};

/***/ })

});


// WEBPACK FOOTER //
// component---tmp-level-docs-js-d97f323eda92736a63c7.js